<template>
  <ModalDialog />
<!--   <div v-if="expertMode">
    <button class="btn btn-outline-primary" @click="expertMode=false">Close Expert mode</button>
    <div class="text-danger">
      <b>Diese Ansicht dient nur zur Kontrolle der Berechnung. 
      Auf der original Webseite darf dieser Modus nicht landen und muss rechtzeitig entfernt werden! <br>
      Zudem ist diese Ansicht nicht Resourcenschonend und verursacht längere Ladezeiten</b>
    </div>
    <EnergyCounterExtreme />
  </div>
  <div v-if="!expertMode">
    <button class="btn btn-outline-primary" @click="expertMode=true">Show Expert mode</button> -->
    <EnergyCounter />


</template>

<script setup>
import {onMounted } from "vue"
//import EnergyCounterExtreme from './components/EnergyCounterExtreme.vue';
import EnergyCounter from './components/EnergyCounter.vue';
import{ useI18n } from 'vue-i18n'
import ModalDialog from "./begComponents/ModalDialog/ModalDialog.vue";

onMounted(() => {
  const pathnames = new URL(window.location.href).pathname.split("/")
    if(pathnames[1] != "preview.php") {
      changeLanguage(pathnames[1]);
    } else if(pathnames[2] != undefined) {
      changeLanguage(pathnames[2]);
    } else {
      changeLanguage("en");
    }
})

//const expertMode = ref(false)

function changeLanguage(langCode) {
  const { locale  } = useI18n()
  locale.value = langCode
}
</script>

<style lang="scss">

#energyCounter {
  line-height: normal;
/*   body {
    font-size: 20px;
  } */
  @import "./../../beg-layout/src/begComponents/style/scss/index.scss";
  * {
    box-sizing: border-box;
  }

  font-family:  Glober, Arial, sans-serif;;
}
</style>
